module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("chapter 5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/29.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_vm._v("1990 BLACK VOLVO MODEL 740")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("Gabriel stretched out")]), _vm._v(" in the backseat, but the minute sneakers met leather…")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“If you lay down back there, take your sneakers off.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gabriel moved his legs slightly, so his feet just dangled over the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Gabriel, I’m serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dad, they’re not touching the leather.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Gabriel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With a grumpy sigh, Gabriel sat up.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dad and his pristine leather seats, fuck him. What’s with him and this car? Gabriel thought as he stared out the window. It was all so boring. Another day with his parents. Another drive in the “fantastic Swedish machine.” Tedium.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This would have been a great day for jamming with his band or just hanging out in his room listening to records and smoking a little weed. But once again he was forced to endure the unbearable ritual of the drive.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was just a pretext for taking a spin in his Dad’s brand new Volvo Turbo. Fuck him. And fuck pristine leather. And fuck Swedish engineering too.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gabriel was so sick of hearing this crap.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The only thing that excited Gabriel about his father’s new car was the sound of its engine. He liked that. He imagined recording it in all different ways. How would it sound, he wondered, if he poured two pounds of sugar into the gas tank? What if it blew up, or was showered with a powerful acid? How would it sound then? Gabriel imagined amplifying "), _c('a', {
    attrs: {
      "id": "page31"
    }
  }), _vm._v("and replaying, in slow motion, the sputter of gasoline as it combusted inside the pistons. Gabriel had no love of cars. Music and sound were his passions…his obsessions, they were what he knew best.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A penchant for sonic experimentation awakened in him when he discovered Hans Heusser and Albert Savinio, the Dadaist musicians of the early twentieth century, industrial bands from the eighties like Throbbing Gristle and Coil, and the synth-pop groups Art of Noise and OMD. After diving deep into numerous avant-garde bands and immersing himself in the entire musical spectrum, inch by inch he formed his own concept of what music should be. One of his first compositions was based on a Diana Ross record played backward.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sound fascinated him, from the crackle of static electricity to the brutal, sordid, macabre, and raw qualities of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Einstürzende Neubauten")]), _vm._v(". He was also fascinated by playful compositions, elegant sound collages, and smart paraphrases of the Pixies, Bad Brains, and even the Carpenters. His taste was eclectic. He enjoyed Stravinsky and folkloric "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("jarocho")]), _vm._v(" songs from Veracruz. He liked listening to pop, he loved the most demented virtuoso performances, and he could fall into a virtual trance surrounded by the loud and ferocious sound of prog-metal. He didn’t have a favorite genre. He believed that styles should merge and fuse in order to produce something more vital. He knew that was what he wanted to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He had no doubt that he was meant to be a musician. The only reason he hadn’t already quit school was that it was the best place to meet girls. Of course, there was the little detail that his parents would never, in a million years, allow that, even though they generally supported his musical adventures. Their support was no small matter; his acoustic arrangements were loud, incoherent cacophonies of incongruous sounds that would drive anybody crazy—and frequently did. They always encouraged his desire to be a musician, as long as he finished high school and got into the conservatory first. Likewise, if he continued with photography, he would have to take it seriously and probably go to art school. This, they said, would allow him time to give it careful consideration, to avoid making a decision he’d regret.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page32"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Imagine what it would be like if you realized at forty that you chose the wrong profession. Just think about how hard it would be to change your direction at that stage,” his father always said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gabriel knew he was right. The life of a musician could be difficult. Most ended up doing menial jobs just to put food on the table. On one occasion he had even answered his father by saying: “I don’t plan on living that long.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Because of this offhand remark, Gabriel’s parents sent him to a psychologist. Dr. Krauss. Right out of central casting, he was bald and bearded, with a stern mouth and soft, considerate eyes. By the second session Gabriel had the doctor snowed. He made Krauss believe that he had religious hallucinations, homosexual desires, parricidal instincts, and later, as he improved his routine, bulimia and attention deficit disorder.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gabriel read psychiatry books to better craft his imaginary conditions. He studied Freud, quoting cases verbatim, leaving Dr. Krauss confused and frustrated. After six months he resigned from treatment. A final admission that Gabriel was immune to his methods and techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To the untrained ear, Gabriel’s music sounded chaotic, an auditory jumble. Yet a patient, educated ear heard form and structure. Gabriel had a natural aptitude for composition. He created strangely elaborate soundscapes: canons, fugues, exceptional paraphrases and interpretations of a variety of musical forms, both classical and popular. Of course, few people understood what he was trying to do. Since he didn’t have any formal training, he could only write rudimentary music, which often didn’t fully express what he intended.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But it didn’t matter. He felt music. It was his language. He could say things with tone, note, and meter that he could never have done with words.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While Gabriel listened to the engine, his father fiddled with the car’s numerous gadgets, turning handles, pushing buttons, changing the radio station. He switched quickly from classical music to an interview with an astronomer discussing radio telescopes, and then to “Sympathy for the Devil” by the Rolling Stones. He looked back at Gabriel:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page33"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Do you want to hear the real masters?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Stop fooling around and focus on the road. I don’t like the way that van is driving in front of us,” said his mother. She had been very quiet up to now.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not crazy about the Stones,” said Gabriel.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you mean? The Stones started everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yeah,” answered Gabriel without any interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Okay, your loss,” said his father, and he changed the station again.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then Gabriel noticed the gray van that had worried his mother. It swerved wildly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A deep voice came over the radio: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You really should listen…")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b80db280","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter05.vue
// module id = 87
// module chunks = 0